export enum LoadState {
    Loading = 1,
    Initialized = 2,
    Uninitialized = 3,
}

export default LoadState;
